import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

export const list = async (roundID) => {
  //* Cache Bust URL variable for IE11
  const cacheBustID = roundID.split('/')[1] || '';
  const [id] = roundID.split('/?');

  try {
    const response = await axiosInstance.get(`/rounds/${id}/shots${cacheBustID}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const actions = async (roundID) => {
  try {
    const response = await axiosInstance.get(`/rounds/${roundID}/actions`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Shot details for top view data overlay details
export const shotview = async (shotID) => {
  try {
    const response = await axiosInstanceCached.get(`/shotview/${shotID}`, {
      id: `shotview_${shotID}`,
      cache: {
        ttl: 1000 * 60 * 20,
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
